<template>
  <div class="row">
    <div
      :class="
        isCompany
          ? `col-lg-6 d-none d-lg-block bg-login-image`
          : `col-lg-6 d-none d-lg-block bg-login-stu-image`
      "
    ></div>
    <div class="col-lg-6">
      <div class="p-5">
        <div class="text-center">
          <h1 class="h4 text-gray-900 mb-2">Welcome to</h1>
          <h1 class="h5 text-gray-900 mb-4">
            Faculty of Engineering's Jobfair Online
          </h1>
        </div>
        <div class="text-center d-flex justify-content-center mb-4">
          <img
            src="assets/img/KMUTT_CI.svg"
            class="img-fluid"
            style="height:120px; padding: 20px"
          />
          <img
            src="assets/img/kmutt-jobfair-logo.png"
            class="img-fluid"
            style="height:120px;padding: 20px 20px 10px;"
          />
        </div>
        <form class="user" @submit.prevent="onSubmit">
          <div class="form-group">
            <label v-if="!isCompany" for="formUsername">Student ID</label>
            <input
              id="formUsername"
              :type="isCompany ? 'email' : 'text'"
              v-model="form.username"
              class="form-control form-control-user"
              aria-describedby="emailHelp"
              :placeholder="
                isCompany ? `Enter Email Address...` : `Enter Your Student ID`
              "
            />
          </div>
          <div class="form-group">
            <label v-if="!isCompany" for="formPassword">Password</label>
            <input
              id="formPassword"
              type="password"
              v-model="form.password"
              class="form-control form-control-user"
              placeholder="Password"
            />
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox small">
              <input
                type="checkbox"
                class="custom-control-input"
                id="loginRemember"
              />
              <label class="custom-control-label" for="loginRemember"
                >Remember Me</label
              >
            </div>
          </div>
          <button type="submit" class="btn btn-danger btn-user btn-block">
            Login
          </button>
        </form>
        <hr />
        <div class="text-center">
          <router-link v-if="isCompany" class="small" to="forgotPassword"
            >Forgot Password?</router-link
          >
          <a v-else class="small" href="https://myaccount.kmutt.ac.th/accountactivation-app/recovery-account"
            >Forgot Password?</a
          >
        </div>
        <div class="text-center" v-if="isCompany">
          <router-link class="small" to="register"
            >Create an Account!</router-link
          >
        </div>
      </div>
    </div>
    <confirmation-modal
        customId="under"
        event-name="under"
        @under="under"
        confirmationType="under"
        cancelTitle="ย้อนกลับ"
        submitTitle="กลับสู่หน้าหลัก"
    />
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import confirmationModal from "../../../shared/components/modal/confirmationModal";
export default {
  name: "loginForm",
  props: {
    isCompany: Boolean,
    isUnder: {
      type: Boolean,
      default: false
    }
  },
  components: {
    confirmationModal
  },
  computed: {
    ...mapGetters(["getKmuttStatus", "getKmuttToken"])
  },
  data() {
    return {
      form: {
        username: "",
        password: ""
      },
      show: true
    };
  },
  mounted() {
    if (this.isUnder) {
      this.$bvModal.show('under')
    }
  },
  methods: {
    ...mapActions(["login", "kmuttLogin"]),
    under(value) {
      if (!value.value) {
        return;
      }
      this.$router.push({path: "/"})
      // this.commitStatus(this.$route.params.uid, value.type)
    },
    onSubmit() {
      if (this.isCompany) {
          this.login(this.form)
          .then(() => {
              // this.$router.push({path: "/emailVerify"});
              this.$router.push({path: "/company/information"});
          })
          .catch()
      } else {
        this.kmuttLogin({username: this.form.username, password: this.form.password})
          .then(() => {
            if (this.getKmuttToken !== ``) {
              if (this.getKmuttStatus === `admin`) {
                this.$router.push({path: "/admin/dashboard"})
              } else {
                this.$router.push({path: "/"})
              }
            }
          })
      }
    }
  }
};
</script>

<style scoped></style>
